(() => {

  /* ----------------------------------------
   * Hero video
   * ---------------------------------------- */
  const hero = document.querySelector(".js-hero-video");
  if (!hero) return;

  let videos = JSON.parse(hero.dataset.videos || "[]");
  if (!videos.length) return;

  let index = 0;
  let active = 0;
  let started = false;

  const videoEls = hero.querySelectorAll(".hero-video");

  // Autoplay compliance
  videoEls.forEach(v => {
    v.muted = true;
    v.playsInline = true;
    v.autoplay = true;
    v.preload = "metadata";
  });

  // Shuffle once
  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
  shuffle(videos);

  function play(videoEl, src) {
    if (videoEl.src !== src) {
      videoEl.src = src;
      videoEl.load();
    }
    const p = videoEl.play();
    if (p) p.catch(() => {});
  }

  function start() {
    if (started) return;
    started = true;

    const first = videoEls[active];
    first.classList.add("is-active");
    play(first, videos[index]);

    index = (index + 1) % videos.length;
  }

  function playNext() {
    const current = videoEls[active];
    const next = videoEls[1 - active];

    play(next, videos[index]);

    next.onplaying = () => {
      next.onplaying = null;

      current.classList.remove("is-active");
      next.classList.add("is-active");
      current.pause();

      active = 1 - active;
      index = (index + 1) % videos.length;
    };
  }

  videoEls.forEach(v =>
    v.addEventListener("ended", playNext)
  );

  /* ----------------------------------------
   * Lazy + idle start (PERF CRITICAL)
   * ---------------------------------------- */
  const idle = window.requestIdleCallback || function (cb) {
    setTimeout(cb, 200);
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return;

      idle(() => start()); // 👈 LCP first, video later
      observer.disconnect();
    },
    { threshold: 0.2 }
  );

  observer.observe(hero);

})();

/* ----------------------------------------
 * iOS autoplay fallback
 * ---------------------------------------- */
document.addEventListener("touchstart", () => {
  const activeVideo = document.querySelector(".hero-video.is-active");
  if (activeVideo && activeVideo.paused) {
    activeVideo.play();
  }
}, { once: true });

window.addEventListener('load', () => {
  const openAcc = (acc) => acc.classList.add('open');

  const closeAcc = (acc, event) => {
    if ((event.type === 'mouseout' && !acc.contains(event.relatedTarget)) || (event.type === 'touchend' && (!event.target.closest('.hero__acc') || event.target.closest('.hero__acc') !== acc))) {
      acc.classList.remove('open');
    }
  }

  document.addEventListener('mouseover', e => { const acc = e.target.closest('.hero__acc'); if (acc) openAcc(acc); });
  document.addEventListener('mouseout', e => { const acc = e.target.closest('.hero__acc'); if (acc) closeAcc(acc, e); });
  document.addEventListener('touchstart', e => { const acc = e.target.closest('.hero__acc'); if (acc) openAcc(acc); });
  document.addEventListener('touchend', e => { const acc = e.target.closest('.hero__acc'); if (acc) closeAcc(acc, e); });

  const menu = document.querySelector('#nav-hero');
  const activeItem = menu?.querySelector('.current-menu-item, .current_page_item');

  if (menu && activeItem) {
    activeItem.scrollIntoView({
      inline: 'center',
      block: 'nearest',
    });
  }
});
